'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Modal = require('../Modal/Modal.js');
var SelectAdvanced = require('../SelectAdvanced/SelectAdvanced.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-menu',
    cnOpen = "".concat(CLASSNAME, "--open"),
    cnFlyIn = "".concat(CLASSNAME, "__fly-in"),
    cnGroups = "".concat(CLASSNAME, "__groups"),
    cnGroupsScrollBottom = "".concat(cnGroups, "--scroll-bottom"),
    cnGroupsOuterWrapper = "".concat(cnGroups, "__outer-wrapper"),
    cnGroupsInnerWrapper = "".concat(cnGroups, "__inner-wrapper"),
    cnGroup = "".concat(CLASSNAME, "__group"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnLink = "".concat(CLASSNAME, "__link"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnOverlay = "".concat(CLASSNAME, "__overlay"),
    cnContentWrapper = "".concat(CLASSNAME, "__content-wrapper"),
    cnHome = "".concat(CLASSNAME, "__home"),
    cnHomeButton = "".concat(cnHome, "__button"),
    cnHomeIcon = "".concat(cnHome, "__icon"),
    cnModal = "".concat(CLASSNAME, "__modal"),
    cnModalContent = "".concat(cnModal, "__content"),
    cnModalButton = "".concat(cnModal, "__button");
/**
 * 
 */

var Menu = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Menu, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Menu);

  function Menu() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {});

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onScroll", function (e) {
      if (_this.timeout) {
        window.clearTimeout(_this.timeout);
      }

      var target = e.target;
      _this.timeout = window.setTimeout(function () {
        _this.onScrollEnd(target);
      }, 100);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Menu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var open = this.props.open,
          fn = open ? 'add' : 'remove';

      if (typeof document !== 'undefined') {
        document.body.classList[fn](cnOpen);
      }
    }
  }, {
    key: "onScrollEnd",
    value: function onScrollEnd(target) {
      var scrollBottom = target.offsetHeight + target.scrollTop >= target.firstElementChild.offsetHeight;
      this.setState({
        scrollBottom: scrollBottom
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          open = _this$props.open,
          languages = _this$props.languages,
          innerRef = _this$props.innerRef,
          onClose = _this$props.onClose,
          locale = _this$props.locale,
          i18n = _this$props.i18n,
          mobile = _this$props.mobile,
          onLanguageSave = _this$props.onLanguageSave,
          contactLink = _this$props.contactLink,
          _this$state = this.state,
          languageModalOpen = _this$state.languageModalOpen,
          scrollBottom = _this$state.scrollBottom,
          newLocale = _this$state.newLocale,
          maxHeight = _this$state.maxHeight;
      var countrySelected = languages.find(function (a) {
        return a === null || a === void 0 ? void 0 : a.options.find(function (b) {
          return b.name === locale;
        });
      });
      var languageSelected = countrySelected === null || countrySelected === void 0 ? void 0 : countrySelected.options.find(function (a) {
        return a.name === locale;
      });
      return /*#__PURE__*/React__default.createElement("div", {
        ref: innerRef,
        className: classNames(CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, cnOpen, open))
      }, /*#__PURE__*/React__default.createElement("nav", {
        className: cnFlyIn,
        style: {
          maxHeight: maxHeight
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnContentWrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnGroups, _rollupPluginBabelHelpers.defineProperty({}, cnGroupsScrollBottom, scrollBottom)),
        onScroll: this.onScroll
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnGroupsOuterWrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnGroupsInnerWrapper
      }, items.map(function (group, index) {
        var _group$items;

        return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
          key: index
        }, group.title && /*#__PURE__*/React__default.createElement("h4", {
          className: cnTitle
        }, group.title), /*#__PURE__*/React__default.createElement("ul", {
          className: cnGroup
        }, (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(function (item) {
          return /*#__PURE__*/React__default.createElement("li", {
            className: cnItem,
            key: item.id
          }, /*#__PURE__*/React__default.createElement(Link, {
            link: item.link,
            className: cnLink,
            onClick: item.onClick
          }, /*#__PURE__*/React__default.createElement("span", null, item.title)));
        })));
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: cnHome
      }, /*#__PURE__*/React__default.createElement(Link, _rollupPluginBabelHelpers.extends({
        className: cnHomeButton
      }, contactLink), /*#__PURE__*/React__default.createElement(Icon, {
        id: "envelope",
        size: "sm",
        className: cnHomeIcon
      }), i18n.contact, /*#__PURE__*/React__default.createElement(MaterialDrop, null)), countrySelected && /*#__PURE__*/React__default.createElement("button", {
        className: cnHomeButton,
        onClick: function onClick() {
          return _this2.setState({
            languageModalOpen: true
          });
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "flag-".concat(languageSelected.name),
        size: "sm",
        className: cnHomeIcon
      }), languageSelected.country === languageSelected.language ? languageSelected.country : "".concat(languageSelected.country, " - ").concat(languageSelected.language), /*#__PURE__*/React__default.createElement(MaterialDrop, null)), /*#__PURE__*/React__default.createElement(Link, {
        link: "/".concat(locale),
        className: cnHomeButton
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "home",
        size: "sm",
        className: cnHomeIcon
      }), i18n.homepage, /*#__PURE__*/React__default.createElement(MaterialDrop, null))))), /*#__PURE__*/React__default.createElement("div", {
        className: cnOverlay,
        onClick: onClose
      }), /*#__PURE__*/React__default.createElement(Modal, {
        open: languageModalOpen,
        onClose: function onClose() {
          return _this2.setState({
            languageModalOpen: false
          });
        },
        className: cnModal,
        classNameContent: cnModalContent,
        showCloseButton: true,
        fullscreen: mobile,
        title: i18n.marketTitle
      }, /*#__PURE__*/React__default.createElement(SelectAdvanced, {
        title: i18n.marketLabel,
        placeholder: i18n.placeholder,
        checkbox: true,
        options: languages,
        defaultValue: locale,
        onChange: function onChange(value) {
          return _this2.setState({
            newLocale: value
          });
        }
      }), /*#__PURE__*/React__default.createElement(ButtonPlain, {
        className: cnModalButton,
        title: i18n.save,
        onClick: function onClick() {
          onLanguageSave(newLocale || languageSelected);

          _this2.setState({
            languageModalOpen: false
          });
        }
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.open && typeof window !== 'undefined') {
        return {
          maxHeight: window.innerHeight
        };
      }

      return null;
    }
  }]);

  return Menu;
}(React__default.Component);
Menu.propTypes = {
  /** Link to home page */
  contactLink: PropTypes.string,

  /** Translation object */
  i18n: PropTypes.shape({
    homepage: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    save: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    marketTitle: PropTypes.string.isRequired,
    marketLabel: PropTypes.string.isRequired,
    contact: PropTypes.string.isRequired
  }).isRequired,

  /** Ref */
  innerRef: PropTypes.any,

  /** Array of items for menu */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.array
  })),

  /** Array of available languages */
  languages: PropTypes.array,

  /** Country code for language */
  locale: PropTypes.string,

  /** True for mobile styling */
  mobile: PropTypes.bool,

  /** Callback function */
  onClose: PropTypes.func,

  /** Callback function on language save */
  onLanguageSave: PropTypes.func,

  /** True for open menu */
  open: PropTypes.bool
};
Menu.defaultProps = {
  i18n: {},
  items: [],
  languages: [],
  onClose: function onClose() {
    return void 0;
  },
  onLanguageSave: function onLanguageSave() {
    return void 0;
  }
};

module.exports = Menu;
